import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import mapProductPriceHistoryRecord from './mapProductPriceHistoryRecord';
import ProductPriceHistoryErrorResponse from './ProductPriceHistoryErrorResponse';
import ProductPriceHistoryRecord from './ProductPriceHistoryRecord';

export interface Result {
	items: ProductPriceHistoryRecord[];
}

export default function findProductPriceHistory(
	client: ApiClient,
	productId: string,
	currency: string | null
): Promise<Result> {
	const url = parseTemplate('products/{productId}/prices-history{?currency}');
	const parameters = { productId, currency };

	return client
		.fetch(url.expand(parameters))
		.then((response) => response.json())
		.then((response) => ({
			items: response.items.map(mapProductPriceHistoryRecord),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, ProductPriceHistoryErrorResponse));
}
